export const setSubTierAgencyList = (state) => ({
    type: 'SET_SUB_TIER_AGENCY_LIST',
    subTierAgencies: state
});
export { setSubTierAgencyList as default };
